import React from 'react'
import CashbackIcon from '@assets/img/reservation/cashback.svg'
import './cashback-widget.scss'


const CashbackDisplay = ({ price, title, style }) => {
    return (
        <a href="/oferta-specjalna/vacationclub-cashback-1-309"
           className="cashback-widget"
           style={style}
           target="_blank"
        >
            <img src={CashbackIcon} alt="Cashback icon" className="cashback-widget__icon" />
            <div className="cashback-widget__title">
                <b>CASHBACK</b> {title}
            </div>
            <div className="cashback-widget__price"><b>{price.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>&nbsp;PLN</div>
        </a>
    )
}

export default CashbackDisplay
